import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";

// Inject dependencyHash to prevent direct imports of dependencies
function store(dependencyHash) {
  return {
    actions: actions(dependencyHash),
    getters: getters(dependencyHash),
    mutations: mutations(dependencyHash),
    state: state(dependencyHash),
  };
}

export default store;
